module.exports = __webpack_public_path__ + "static/media/minus-button.90f6ad60.png";